import { render } from "./ProductFiles.vue?vue&type=template&id=0fa802f1&scoped=true"
import script from "./ProductFiles.vue?vue&type=script&lang=js"
export * from "./ProductFiles.vue?vue&type=script&lang=js"

import "./ProductFiles.vue?vue&type=style&index=0&id=0fa802f1&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\external\\kazigraphix\\admin.kazigraphix\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa802f1"]])

export default __exports__